import React, { useState } from 'react';
import { useModelsModalState, setModelsModalState } from '../../../../store/state';
import { getCollectData } from '../../fetchList';
import { useAsyncEffect } from 'ahooks';

export const useFetchList = (modelType) => {
  const collectType = useModelsModalState('collectType');
  const [loading, setLoading] = useState(false);
  useAsyncEffect(async () => {
    setLoading(true);
    const res = await getCollectData(modelType, collectType);
    setModelsModalState({
      collectModels: {
        [collectType]: res,
      },
    });
    setLoading(false);
  }, [collectType]);

  return { loading, collectType };
};
